import { render, staticRenderFns } from "./regionIndex.vue?vue&type=template&id=a71c39c0&scoped=true"
import script from "./regionIndex.vue?vue&type=script&lang=js"
export * from "./regionIndex.vue?vue&type=script&lang=js"
import style0 from "./regionIndex.vue?vue&type=style&index=0&id=a71c39c0&prod&lang=scss&scoped=true"
import style1 from "./regionIndex.vue?vue&type=style&index=1&id=a71c39c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71c39c0",
  null
  
)

export default component.exports